import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarObjectUsers } from '../../../api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const getCoreSonarObjectsUsersSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateSonarObjectReferences([
					{
						sonarObjectId: request.sonarObjectId,
						users: response
					}
				])
		]
	},
	name: 'CoreSonarObjectsUsers',
	receive: true,
	request: true,
	requestHandler: getSonarObjectUsers
});
